import React, { useEffect } from "react";
import usePaginationV2 from "../util/usePaginationV2";
import { useTranslation } from "react-i18next";
import ABPYRKodlarservice from "../service/SGKABPYRKodlarService";
import sgkeviziterapordurumlari from "../service/SGKEviziterapordurumlariService";
import iksubelerservice from "../service/IKServices/IKSubelerService";
import SysRolservice from "../service/IKIseAlimServices/SysRolService";
import masterTenantservice from "../service/MasterServices/MasterTenantService";
import Menulerservice from "../service/GeneralServices/MenulerService";
import Sirketlerservice from "../service/SGKSirketlerService";
import sablonTipleriService from "../service/SablonServices/SablonTipleriService";
import Sehirservice from "../service/GeneralServices/SehirService";
import BatchOperationservice from "../service/MasterServices/BatchOperationService";
import SysGlobalGroupservice from "../service/MasterServices/SysGlobalGroupService";
import Moduleservice from "../service/GeneralServices/ModuleService";
import IKKategorilerService from "../service/IKServices/IKKategorilerService";

const serviceConfig = {
  ABPYRKodlar: {
    service: ABPYRKodlarservice,
    valueField: "kod",       // field to use for option value
    displayField: "aciklama" // field to use for display text
  },
  SGKEviziterapor: {
    service: sgkeviziterapordurumlari,
    valueField: "id",        // field to use for option value
    displayField: "aciklama" // field to use for display text
  }
  ,
  IKSubelerservice: {
    service: iksubelerservice,
    valueField: "subeKodu",        // field to use for option value
    displayField: "subeAdi" // field to use for display text
  },
  SysRolservice: {
    service: SysRolservice,
    valueField: "rol",        // field to use for option value
    displayField: "rol" // field to use for display text
  },
  MasterTenant: {
    service: masterTenantservice,
    valueField: "id",        // field to use for option value
    displayField: "name" // field to use for display text
  },
  Sirketler: {
    service: Sirketlerservice,
    valueField: "sirketKodu",        // field to use for option value
    displayField: "sirketAdi" // field to use for display text
  },
  SablonTipleri: {
    service: sablonTipleriService,
    valueField: "id",        // field to use for option value
    displayField: "tipAdi" // field to use for display text
  },
  Menuler: {
    service: Menulerservice,
    filter: {
      sistem: "SGK",
      isGroup: true
    },
    valueField: "id",
    displayField: "baslik",
  },
  IKKategoriler: {
    service: IKKategorilerService,
    filter: {
      isGroup: true
    },
    valueField: "kod",
    displayField: "kategoriAdi",
  },
  Tenant: {
    service: masterTenantservice,
    valueField: "id",
    displayField: "name",
  },
  Sehir: {
    service: Sehirservice,
    valueField: "sehirKodu",
    displayField: "sehirAdi",
  }, BatchOperation: {
    service: BatchOperationservice,
    valueField: "operationId",
    displayField: "operationName",
  }, SysGlobalGroup: {
    service: SysGlobalGroupservice,
    valueField: "id",
    displayField: "groupKey",
  }, modules: {
    service: Moduleservice,
    valueField: "id",
    displayField: "moduleName",
  }
};

const DynamicOptions = ({ serviceType }) => {
  const { t } = useTranslation();

  // Define a configuration for each service


  // Get the correct config based on serviceType
  const config = serviceConfig[serviceType] || serviceConfig.SGKEviziterapor;

  const list = usePaginationV2({
    service: config.service,
    defaultSearchData: { ...config.filter },
    defaultOrderBy: { name: config.displayField, type: "Asc" },
    takeAll: true
  });

  useEffect(() => {
    if (!list.loading && list.data.length > 0) {
    }
  }, [list.loading]);

  if (list.loading) {
    return <option value="" selected>{t('label.loading')}</option>;
  } else {
    return list.data.map((item, index) => (
      <option key={index} value={item[config.valueField]}>
        {` ${item[config.displayField]}`}
      </option>
    ));
  }
};

export default React.memo(DynamicOptions);
